<div [ngClass]="isError ? 'validation-error' : 'nothing'">
    <div class="validation-copy" innerText="{{ message }}"></div>
</div>
